import styled from 'styled-components'
export const EmptyElement = styled('div')`
  width: auto;
`
export const EmptySpan = styled('span')`
  width: auto;
`

export const EmptyAnchor = styled('a')`
  width: auto;
`
